// src/components/SkeletonCard.jsx
import React from 'react';
import { motion } from 'framer-motion';
import '../styles/main.css';

export default function SkeletonCard() {
    return (
        <motion.div
            className="skeleton-card"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
        >
            <div className="skeleton-image shimmer" />
            <div className="skeleton-text shimmer" />
            <div className="skeleton-text short shimmer" />
        </motion.div>
    );
}
